import type { Topic } from '@/@types/topic'
import { notFound, redirect } from '@tanstack/react-router'
import { isEmpty } from 'lodash-es'
import storage from './Storage'
import queryClient from './queryClient'

// redirect to login page if not logged in
export function navigateToLoginPage() {
	storage.auth.token = null
	storage.auth.refreshToken = null
	queryClient.clear()
	const url = new URL(window.location.href)
	url.pathname = '/login'
	url.searchParams.set('redirect', window.location.href)
	window.location.href = url.toString()
}

export function assertTopicRoute(topic: Topic, tab?: string) {
	if (isEmpty(topic.tabs)) {
		throw notFound()
	}

	if (!topic.tabs.find((item) => item.type === tab)) {
		throw redirect({
			to: '/topic/$id/$tab',
			params: {
				id: topic.id,
				tab: topic.tabs[0].type,
			},
			replace: true,
		})
	}
}
